import {
  ActionTargetStep,
  OwnerOptions,
  StepOwnerGroupRelativeOptions,
  WorkflowStepOwner,
  WorkflowStepOwnerSource,
} from '@osos/shared/api';
import {
  AdhocStepTypeEnum,
  StepOwnerModeEnum,
  StepOwnerSelectionCriteriaEnum,
  StepOwnerSourceTypeEnum,
  StepOwnerTypeEnum,
  StepType,
} from '../../enums';
import { WorkflowActionPresenterModel } from './workflow-action-presenter.model';
import { RefProperty } from '../../ref-property.model';
import { TokenSourceType } from '../field-presenter.model';
import { LocalizedValueModel } from '../../localized-value.model';
import { Named } from '../../base/named.model';
import { Identified } from '../../base/identified.type';

export class WorkflowStepPresenterModel implements Identified<string>, Named {
  id: string;
  type: StepType;
  name: LocalizedValueModel;
  description: LocalizedValueModel;
  owner?: WorkflowStepOwnerModel;
  fallbackOwner?: WorkflowStepOwnerModel[];
  actions: WorkflowActionPresenterModel[];
  allowAddAdHoc?: boolean;
  inMainFlow?: boolean;
  mainFlowIndex?: number;
  timeMonitoring?: StepTimeMonitoringPresenterModel;
  subWorkflowId?: string;
  mergeStep?: ActionTargetStep;
}

export enum TimeMonitoringUnitEnum {
  Minutes = 0,
  Hours = 1,
  Seconds = 2,
}

export enum MultiAssignmentType {
  Sequential,
  Parallel,
}

export class StepTimeMonitoringPresenterModel {
  enabled?: boolean;
  workingTimeReference?: null | RefProperty;
  monitoringUnit?: TimeMonitoringUnitEnum | null;
  value?: number | string | null;
  mode?: TokenSourceType | null;
  fallbackValue?: number;
}
export class WorkflowAdhocStepPresenterModel extends WorkflowStepPresenterModel {
  workflowId: string;
  parentStepId: string;
  adhocStepType: AdhocStepTypeEnum;
}
export class WorkflowStepOwnerModel implements WorkflowStepOwner {
  ownerOptions?: StepOwnerOptionsModel;
  source: StepOwnerSourceModel;
  type: StepOwnerTypeEnum;
}

export class StepOwnerOptionsModel implements OwnerOptions {
  allowChangeOwner?: boolean;
  mode?: StepOwnerModeEnum;
  accessPermission?: StepOwnerModeEnum;
  selectionCriteria?: StepOwnerSelectionCriteriaEnum;
  failureActions?: Array<StepOwnerFailureActionsModel>;
  mainActionExecutionCondition?: MainActionExecutionConditionEnum;
  threshold?: StepOwnerThresholdModel;
  isParallel?: boolean;
  returnTo?: TakeOwnershipReturnToModeEnum;
}

export class StepOwnerSourceModel implements WorkflowStepOwnerSource {
  relativeOptions?: StepOwnerRelativeOptionsModel;
  type: StepOwnerSourceTypeEnum;

  /**
   * Either (a reference property to user or group in case of fixed) or (a field normalized name in case of dynamic)
   * In case it is a relative owner the value will be the step id which will the owner be relative to it and the owner will be calculated based on user org_unit
   */
  value: any;

  groupRelativeOptions?: StepOwnerGroupRelativeOptions;
}

export class StepOwnerRelativeOptionsModel {
  /**
   * Is the relative owner enabled
   */
  enabled: boolean;
  relationGrade: number;

  /**
   * The relation type to the previous step owner
   */
  relationType: 0;
}

export class CreateAdhocWorkflowStepModel {
  adhocStepType: 0 | 1;
  fallbackOwner?: Array<WorkflowStepOwnerModel>;
  notes?: string;
  owner: WorkflowStepOwnerModel;
}

export class StepOwnerFailureActionsModel {
  actionId: string;
}
export class StepOwnerThresholdModel {
  type: ThresholdValueTypeEnum;
  value: number;
}
export enum MainActionExecutionConditionEnum {
  AllUsers = 0,
  SomeUsers = 1,
}

export enum TakeOwnershipReturnToModeEnum {
  Group = 0,
  LastOwner = 1,
}
export enum ThresholdValueTypeEnum {
  Percentage = 0,
  Number = 1,
}
